/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoveToExistingDigitalBillDto
 */
export interface MoveToExistingDigitalBillDto {
    /**
     * 
     * @type {string}
     * @memberof MoveToExistingDigitalBillDto
     */
    fromReference: string;
    /**
     * 
     * @type {string}
     * @memberof MoveToExistingDigitalBillDto
     */
    toReference: string;
}

/**
 * Check if a given object implements the MoveToExistingDigitalBillDto interface.
 */
export function instanceOfMoveToExistingDigitalBillDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fromReference" in value;
    isInstance = isInstance && "toReference" in value;

    return isInstance;
}

export function MoveToExistingDigitalBillDtoFromJSON(json: any): MoveToExistingDigitalBillDto {
    return MoveToExistingDigitalBillDtoFromJSONTyped(json, false);
}

export function MoveToExistingDigitalBillDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveToExistingDigitalBillDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromReference': json['fromReference'],
        'toReference': json['toReference'],
    };
}

export function MoveToExistingDigitalBillDtoToJSON(value?: MoveToExistingDigitalBillDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromReference': value.fromReference,
        'toReference': value.toReference,
    };
}

